import { render } from "./plan_edit.vue?vue&type=template&id=14ed19ac&scoped=true"
import script from "./plan_edit.vue?vue&type=script&lang=js"
export * from "./plan_edit.vue?vue&type=script&lang=js"

import "./plan_edit.vue?vue&type=style&index=0&id=14ed19ac&scoped=true&lang=css"

import exportComponent from "/Users/igor.boldin/projects/edit/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ed19ac"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QCard,QCardSection,QTable,QTd,QBtn,QDialog,QForm,QInput,QToggle});qInstall(script, 'directives', {ClosePopup});
